import { all, call, put, takeEvery } from 'redux-saga/effects';
import { getRequest } from '../../../../helpers/axiosClient';
import actions from './actions';

export function* getProductgstDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest('productgst?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest('productgst'));
        }
        yield put({
            type: actions.PRODUCTGST_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.PRODUCTGST_DETAILS_FAILURE });
        return error;
    }
}

export function* getTaxCodeDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest('taxcode?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest('taxcode'));
        }
        yield put({
            type: actions.TAXCODE_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.TAXCODE_DETAILS_FAILURE });
        return error;
    }
}

export function* getOtherTaxesDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest('othertaxes?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest('othertaxes'));
        }
        yield put({
            type: actions.OTHERTAXES_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.OTHERTAXES_DETAILS_FAILURE });
        return error;
    }
}

export function* getCashDiscountDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest('cashdiscount?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest('cashdiscount'));
        }
        yield put({
            type: actions.CASHDISCOUNT_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.CASHDISCOUNT_DETAILS_FAILURE });
        return error;
    }
}

export function* getPartygstDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest('partygst?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest('partygst'));
        }
        yield put({
            type: actions.PARTYGST_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.PARTYGST_DETAILS_FAILURE });
        return error;
    }
}

export function* getCurrencyDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest('currency?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest('currency'));
        }
        yield put({
            type: actions.CURRENCY_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.CURRENCY_DETAILS_FAILURE });
        return error;
    }
}

export function* getWalletDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest('wallet?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest('wallet'));
        }
        yield put({
            type: actions.WALLET_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.WALLET_DETAILS_FAILURE });
        return error;
    }
}

export function* getMopDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest('mop?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest('mop'));
        }
        yield put({
            type: actions.MOP_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.MOP_DETAILS_FAILURE });
        return error;
    }
}


export function* getHsnDetails(params) {
    try {
        let response = '';
        if (params.filter) {
            response = yield call(() => getRequest('hsns?filter=' + encodeURIComponent(JSON.stringify(params.filter))));
        } else {
            response = yield call(() => getRequest('hsns'));
        }
        yield put({
            type: actions.HSN_DETAILS_SUCCESS,
            payload: response.data,
            export: params.export,
            data: params.data,
            selected: params.selected,
            extension: params.extension
        });
    } catch (error) {
        yield put({ type: actions.HSN_DETAILS_FAILURE });
        return error;
    }
}


export default function* adminSetupSaga() {
    yield all([
        takeEvery(actions.PRODUCTGST_DETAILS_START, getProductgstDetails),
        takeEvery(actions.TAXCODE_DETAILS_START, getTaxCodeDetails),
        takeEvery(actions.OTHERTAXES_DETAILS_START, getOtherTaxesDetails),
        takeEvery(actions.CASHDISCOUNT_DETAILS_START, getCashDiscountDetails),
        takeEvery(actions.PARTYGST_DETAILS_START, getPartygstDetails),
        takeEvery(actions.CURRENCY_DETAILS_START, getCurrencyDetails),
        takeEvery(actions.WALLET_DETAILS_START, getWalletDetails),
        takeEvery(actions.MOP_DETAILS_START, getMopDetails),
        takeEvery(actions.HSN_DETAILS_START, getHsnDetails)
    ]);
}